import React, { useState } from "react";
import CustomInputBox from "../Form/CustomInputBox";
import { GoOrganization } from "react-icons/go";
import { FaPhoneAlt } from "react-icons/fa";
import { CiGlobe } from "react-icons/ci";
import { LuUsers2 } from "react-icons/lu";
import apiClient from "../../services/apiClient";
import toast from "react-hot-toast";
import CustomButton from "../Button/CustomButton";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setUserDetails } from "../../features/user/UserSlice";

const CreateCompany = ({ user_id }) => {
  const [loading, setLoading] = useState(false);

  const userInfo = useSelector((state) => state?.userInfo?.user);
  const dispatch = useDispatch();

  const [userDetail, setUserDetail] = useState({
    company_name: "",
    domain: "",
    no_of_employees: "",
    contact_number: "",
  });

  const navigate = useNavigate();

  const handleCreateCompany = async (e) => {
    e.preventDefault();
    setLoading(true);

    // console.log(data);

    const companyData = {
      ...userDetail,
      company_owner: user_id, // Use the logged-in user ID here
      created_from: "VOIP",
      company_website: "",
    };

    try {
      const response = await apiClient.post("/companies", companyData);

      dispatch(
        setUserDetails({
          id: response?.data?.user?._id,
          company_id: response?.data?.user?.company_id,
          name: response?.data?.user?.name,
          email: response?.data?.user?.email_id,
          phone_number: response?.data?.user?.phone_number,
          image: response?.data?.user?.image,
          role: response?.data?.user?.user_type,
          company_domain: response?.data?.company_details?.domain,
          settings: response?.data?.user?.settings,
        })
      );

      // Handle the API response
      toast.success("Company created!");
      if (userInfo?.name) navigate("/");
      else navigate("/profile-page");
    } catch (error) {
      console.log("Failed to create company. Please try again.");
      toast.error("Oops! An error occurred Please try again!");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserDetail((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  return (
    <div className="w-75">
      <h3 className="title">Fill in & Get Started!</h3>
      <form onSubmit={handleCreateCompany}>
        <CustomInputBox
          placeholder=""
          type="text"
          required={true}
          name="company_name"
          icon={GoOrganization}
          borderRadius="4px"
          margin={"20px 0px"}
          backgroundColor={"white"}
          variant="outlined"
          label="Company name"
          onChange={handleChange}
          value={userDetail?.company_name}
        />
        <CustomInputBox
          placeholder=""
          type="number"
          name="contact_number"
          required={true}
          icon={FaPhoneAlt}
          borderRadius="4px"
          margin={"20px 0px"}
          backgroundColor={"white"}
          variant="outlined"
          label="Phone no"
          onChange={handleChange}
          value={userDetail?.contact_number}
        />
        <CustomInputBox
          placeholder=""
          type="text"
          name="domain"
          required={true}
          icon={CiGlobe}
          borderRadius="4px"
          margin={"20px 0px"}
          backgroundColor={"white"}
          variant="outlined"
          label="Domain"
          onChange={handleChange}
          value={userDetail?.domain}
        />
        <CustomInputBox
          placeholder=""
          type="number"
          name="no_of_employees"
          required={true}
          icon={LuUsers2}
          borderRadius="4px"
          margin={"20px 0px"}
          backgroundColor={"white"}
          variant="outlined"
          label="No. of Employees"
          onChange={handleChange}
          value={userDetail?.no_of_employees}
        />
        <CustomButton type="submit" className="my-2" width={"100%"} size="large" loading={loading}>
          Submit
        </CustomButton>
      </form>
    </div>
  );
};

export default CreateCompany;
